export const SHOW_MODAL = '@app/SHOW_MODAL';
export const HIDE_MODAL = '@app/HIDE_MODAL';
export const MODAL_CONFIRMED = '@app/MODAL_CONFIRMED';

export interface ModalContent {
  title?: string;
  description?: string;
  buttonText?: string;
  onConfirm?: () => void;
}

export interface ModalState {
  isOpen?: boolean;
  content: ModalContent;
}
